const settingsConfig = {
  layout: {
    style: "layout1", // layout-1 layout-2 layout-3
    config: {}, // checkout layout configs at app/fuse-configs/layout-1/Layout1Config.js
  },
  customScrollbars: true,
  theme: {
    main: "default",
    navbar: "mainThemeLight",
    toolbar: "mainThemeLight",
    footer: "mainThemeLight",
  },
};

export default settingsConfig;
